import { Component, Input, input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { AttachmentsComponent } from '../../components/attachments/attachments.component';
import { InfoBoxComponent } from '../../components/info-box/info-box.component';
import { ResultsComponent } from '../../components/results/results.component';
import { ApiService } from '@app/services/api.service';
import { AnalysisResponse, TaskSummary } from '@app/models/analysis.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-analysis',
    standalone: true,
    imports: [
        CommonModule,
        HeaderComponent,
        AttachmentsComponent,
        InfoBoxComponent,
        ResultsComponent,
        MatProgressSpinnerModule,
    ],
    templateUrl: './analysis.component.html',
    styleUrls: ['./analysis.component.scss'],
})
export class AnalysisComponent implements OnInit {
    @Input() evaluationId: string = '';
    @Input() taskId: string = '';
    analysis: AnalysisResponse | undefined;
    loading: boolean = false;

    get isDataLoaded() {
        return !this.loading && this.analysis !== null;
    }

    constructor(
        private route: ActivatedRoute,
        private apiService: ApiService
    ) {}

    ngOnInit(): void {
        this.getCurrentAnalysis();
    }

    async getCurrentAnalysis() {
        this.loading = true;

        try {
            const analysisResponse = await this.apiService.instance.get<AnalysisResponse>(
                `/api/evaluation-results/v1/completion/${this.evaluationId}/${this.taskId}`
            );
            console.log(analysisResponse.data);
            this.analysis = new AnalysisResponse(analysisResponse.data);

            const aspectDetails = await this.apiService.instance.get<TaskSummary>(
                `/api/internal/metadata/v1/task/json/summary?external-id=${this.taskId}`
            );

            this.analysis.updateFactorDetails(aspectDetails.data);
            console.log('Details', aspectDetails.data);
            console.log('analyis', this.analysis);
        } catch (err) {
        } finally {
            this.loading = false;
        }
    }
}
